import { BaseObjectEntity } from '@/types';
import { path } from '@/utils/formatLink';

export const ROOT_AUDIT_LOGS = '/audit-logs';

export const PATH_AUDIT_LOGS: BaseObjectEntity = {
  root: ROOT_AUDIT_LOGS,
  list: '',
};

export function auditLogsPath(pathKey: string) {
  return path(ROOT_AUDIT_LOGS, PATH_AUDIT_LOGS[pathKey]);
}
